'use client';

import { useTranslations } from 'next-intl';
import DocumentPageShell from '@/components/sections/shared/DocumentPageShell';
import type { ComplianceData } from '@/types/compliance';
import ComplianceHeader from './ComplianceHeader';
import ComplianceTabs from './ComplianceTabs';

interface ComplianceProps {
  locale: string;
  data: ComplianceData | null;
}

export default function Compliance({ data }: ComplianceProps) {
  const t = useTranslations('compliance');

  if (!data) {
    return (
      <DocumentPageShell title={t('error.title')} subtitle={<p>{t('error.message')}</p>}>
        <div className="rounded-2xl border border-[#e4e4e4] bg-white p-8 text-center shadow-sm">
          <p className="text-base text-[#737373]">{t('error.message')}</p>
        </div>
      </DocumentPageShell>
    );
  }

  return (
    <DocumentPageShell title={data.pageTitle}>
      <ComplianceHeader subHeadings={data.subHeadings ?? []} />
      <div className="mt-6 sm:mt-8">
        <ComplianceTabs tabs={data.tabs ?? []} />
      </div>
    </DocumentPageShell>
  );
}
